import { render, staticRenderFns } from "./value-input.vue?vue&type=template&id=6bdbe9de&scoped=true&"
import script from "./value-input.vue?vue&type=script&lang=js&"
export * from "./value-input.vue?vue&type=script&lang=js&"
import style0 from "./value-input.vue?vue&type=style&index=0&id=6bdbe9de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdbe9de",
  null
  
)

export default component.exports